var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThrAnalyzedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 40,
    viewBox: "0 0 32 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 15,
    height: 10,
    rx: 0.55,
    transform: "matrix(-1 0 0 1 15 2.5)",
    stroke: "#000F35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.062561,
    y: 5.00427,
    width: 0.1,
    height: 8.16343,
    rx: 0.5,
    transform: "rotate(-61.6552 -0.062561 5.00427)",
    fill: "#000F35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.062561,
    y: 5.00427,
    width: 0.1,
    height: 8.16343,
    rx: 0.5,
    transform: "rotate(-61.6552 -0.062561 5.00427)",
    fill: "#000F35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.062561,
    y: 5.00439,
    width: 0.5,
    height: 9.35755,
    rx: 0.5,
    transform: "rotate(-61.6552 -0.062561 5.00439)",
    fill: "#000F35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.062561,
    y: 5.00439,
    width: 0.5,
    height: 9.35755,
    rx: 0.5,
    transform: "rotate(-61.6552 -0.062561 5.00439)",
    fill: "#000F35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.5,
    height: 9.15698,
    rx: 0.5,
    transform: "matrix(-0.474777 -0.880106 -0.880106 0.474777 16 5.00439)",
    fill: "#000F35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.5,
    height: 9.15698,
    rx: 0.5,
    transform: "matrix(-0.474777 -0.880106 -0.880106 0.474777 16 5.00439)",
    fill: "#000F35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.51917,
    y: 8.51538,
    width: 0.5,
    height: 8.39484,
    rx: 0.5,
    transform: "rotate(-55.1588 8.51917 8.51538)",
    fill: "#000F35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.51917,
    y: 8.51538,
    width: 0.5,
    height: 8.39484,
    rx: 0.5,
    transform: "rotate(-55.1588 8.51917 8.51538)",
    fill: "#000F35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.5,
    height: 8.39484,
    rx: 0.5,
    transform: "matrix(-0.571304 -0.820738 -0.820738 0.571304 7.46613 8.51538)",
    fill: "#000F35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.5,
    height: 8.39484,
    rx: 0.5,
    transform: "matrix(-0.571304 -0.820738 -0.820738 0.571304 7.46613 8.51538)",
    fill: "#000F35"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThrAnalyzedIcon);
export default __webpack_public_path__ + "static/media/thrAnalyzed_icon.583304f1cf57579b7c6cd9e5a5c1da19.svg";
export { ForwardRef as ReactComponent };